//setGeoLocation("cookie-name-here", "cookie-value-here", cookie-expiry-here);
/*
 name: string
 expiry: integer (in days. 0 which means no expiry)
*/
var cookie_expire_int = 90;
var dom_int_tooltip_cookie_name = "tooltip_closed";

function checkIPGeolocation(success, failure)
{
    //Don't do the geolocation check if we're in authoring mode - this will still fire on "View as Published"
    var is_authoring = $('.aem_author_mode').length > 0;
    if(is_authoring){
        return;
    }
	$.ajax({
        method: "GET",
        url: '/flinders-services/ip-geolocate',
    }).done(function (data){
    	console.log("Got geolocation response from server", data);
    	setCookie(dom_int_tooltip_cookie_name, "no", cookie_expire_int, "overwrite");
    	if(data.success)
    	{
    		var location = data.domestic? 'dom':'int';
		    updateOrSetDomIntCookie(location);
		    updateDomIntContentUI(location);
		    setToolTipValue(location);
		    if(typeof(success) == "function")
			{
		    	success();
			}
    	}
    	else
    	{
    		if(typeof(failure) == "function")
			{
    			console.log("IP detection failed, using fallback");
    			failure();
			}
    		else
    		{
    			console.error("IP detection failed, no fallback available!");
    		}
    	}
    });	
}

function setGeoLocation(name, expiry) {
	console.log('Attempting to get geolocation...');
	var geo_location_result = 'AU';
	var current_geo_cookie = getCookie(name);
	var location_settings_enabled = ("geolocation" in navigator);
	var location_has_been_decided = false;
    if (!current_geo_cookie || current_geo_cookie.length === 0) {
    	checkIPGeolocation(function(){
    		location_has_been_decided = true;
    	},
    	function(){
	        if (location_settings_enabled && navigator.geolocation) {
	        	try {            	
	            	navigator.geolocation.getCurrentPosition(
	                    function(position) {
	                		$.ajax({
	                            method: "GET",
	                            url: "https://maps.googleapis.com/maps/api/geocode/json",
	                            data: { latlng:position.coords.latitude+","+position.coords.longitude, sensor: false, key: "AIzaSyCk31-dxBJJw86bIKdhDkdJjgZ7nTp1dOs" }
	                        }).done(function( data ) {
	                        	geo_location_result = data.results[data.results.length - 1].address_components[0].short_name;
	                            setCookie(name, geo_location_result , expiry, "overwrite");
	                            updateAllForLocation(geo_location_result);
	                            location_has_been_decided = true;
	                        });
	                    }, 
	                    function(error) {
	                    	console.log('Error - navigator.geolocation.getCurrentPosition failed: Defaulting to domestic.',error);
	                    	geo_location_result = 'AU';
	                        setCookie(name, geo_location_result, expiry, "overwrite");
	                        updateAllForLocation(geo_location_result);
	                        location_has_been_decided = true;
	                    }, 
	                    {timeout: 12000}
	                );
	        	}
	        	catch(err) {
	        		console.log('Error when trying to get location. Defaulting to Domestic.', err);
	        		setCookie(name, geo_location_result, expiry, "overwrite");
	                updateAllForLocation(geo_location_result);
	                location_has_been_decided = true;
	        	}
	            
	        } else {
	        	console.log('Warning - location services disabled!');
	            setCookie(name, geo_location_result, expiry, "overwrite");
	            updateAllForLocation(geo_location_result);
	            location_has_been_decided = true;
	        }
    	});
    }
    else {
    	console.log('Warning - geolocation cookie already set! ');
    	setCookie(name, geo_location_result, expiry, "overwrite");
        updateAllForLocation(geo_location_result);
        location_has_been_decided = true;
    }
    
    //if all else fails...check again!!
    setTimeout(function(){ 
    	//console.log('Checking if geolocation has been decided...');
    	if(location_has_been_decided) {
        	//console.log('...it has');
    	}
    	else {
    		//console.log('...it has not...setting to defaults');
    		setCookie(name, geo_location_result, expiry, "overwrite");
            updateAllForLocation(geo_location_result);
            location_has_been_decided = true;
    	}
	}, 3000);
}
// To hide DomIntl Tooltip on Switch selection
function hideTooltip(){
    if($('.domIntlToolTip').is(':visible')){
        $('.domIntIcons').tooltip('hide');
    }
}
// DomIntl Tooltip Close btn functionality
function closeToolTip() {
    $('body .tooltip').hide();
    setCookie(dom_int_tooltip_cookie_name, "yes", cookie_expire_int, "overwrite");
};

function updateAllForLocation(location) {
	setCookie(dom_int_tooltip_cookie_name, "no", cookie_expire_int, "overwrite");
	if (!location || location.toUpperCase() === "AU" || location.toUpperCase() === "NZ") {
        updateOrSetDomIntCookie('dom');
        updateDomIntContentUI('dom');
        setToolTipValue('dom');
        
    } else {
        updateOrSetDomIntCookie('int');
        updateDomIntContentUI('int');
        setToolTipValue('int');
    }
}

// To set Tooltip on screen
function setToolTipValue(action){
	setTimeout(function(){ 
		var domIntlText;
	    var tooltip_cookie = getCookie(dom_int_tooltip_cookie_name);
	    var dom_int_tooltip_not_closed = (tooltip_cookie && tooltip_cookie.indexOf('no') > -1);
	    var dom_int_toggle_is_shown = ($('#dom_int_toggle_show_input').val() == 'true');
	    var page_type = $("#conversation_feed_page_type").val();
	    if(action === 'dom'){
	        domIntlText = "domestic student";
	    } else{
	        domIntlText = "international student";
	    }
	    var alertMessage = "You are viewing  <b style='color:#ffd300;'>"+domIntlText+"</b> information. <br/> If this isn't correct, you can change it here.";
	    if (dom_int_toggle_is_shown && dom_int_tooltip_not_closed && !$('.yellow_header .tooltip').length && page_type != 'staff_profile') {
	    	var dom_int_icon_container = $('.navigation-global .domIntIcons');
	    	dom_int_icon_container.attr('data-original-title', alertMessage).tooltip({container: "#dom_int_icon_container", trigger: 'manual',placement:'bottom',offset:[20,0]}).tooltip('show').tooltip('show');
	        // To combat double close btns
	        if( !$('.tooltip .close').length ) {
	            $('.tooltip').append('<button type="button" class="close" tabindex="0" onclick="closeToolTip();">&times;</button>');
	        }
	    }
	}, 1000);
    
}